exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ArrowButton-module__button___oPKqe{padding:.25em;border-radius:10px;font-size:3em}", ""]);

// exports
exports.locals = {
	"button": "ArrowButton-module__button___oPKqe"
};